"use strict";

import React from "react";
import cx from "classnames";

function ControlAddon(props) {
  let { children, baseClassName, className, ...otherProps } = props;

  return (
    <span className={cx(baseClassName, className)} {...otherProps}>
      {children}
    </span>
  );
}

ControlAddon.defaultProps = {
  baseClassName: "si-c-addon",
};

export default ControlAddon;
